import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { subscriber_profile_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import IconArrow from '../Images/Rebranding/IconArrow';
import IconX from '../Images/Rebranding/IconX';

interface AuthorTooltipProps {
  email: string;
  isExternalAuthor: boolean;
  profileEnabled: boolean;
  twitter: string;
  username: string;
}

const AuthorTooltip = ({
  email,
  isExternalAuthor,
  profileEnabled,
  twitter,
  username,
}: AuthorTooltipProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <div
      className="absolute z-[1000] hidden min-w-[195px] bg-grayscale-charcoal p-24 group-hover:block dark:bg-[var(--light-grayscale-charcoal)]"
      {...(isExternalAuthor && { 'data-nosnippet': true })}
    >
      <a
        href={`mailto:${email}`}
        className="mb-16 block font-suisse-screen text-overline-md text-white hover:text-primary-magenta dark:hover:text-primary-pink"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.MailTo }))}
      >
        {email}
      </a>
      {profileEnabled && (
        <a
          href={subscriber_profile_path(username)}
          className="flex items-center font-suisse-intl text-button-sm text-white hover:text-primary-magenta dark:hover:text-primary-pink"
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ProfileAndArchive }))}
        >
          Profile and archive
          <IconArrow className="ml-8 w-16 rotate-180" />
        </a>
      )}
      {twitter && (
        <div className="mt-24 border-0 border-t-2 border-solid border-grayscale-beige pt-24">
          <a
            href={`https://x.com/${twitter}`}
            target="_blank"
            rel="noreferrer"
            data-testid="twitter-link"
            onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.Twitter }))}
          >
            <IconX className="w-16 text-grayscale-beige hover:text-primary-magenta dark:text-white dark:hover:text-primary-pink" />
          </a>
        </div>
      )}
    </div>
  );
};

export default AuthorTooltip;
